import React, { useState } from 'react';
import { useI18n } from '@wordpress/react-i18n';
import { formatNumber } from '../utils';
function getCalculateButtonClassName(color) {
    switch (color) {
        case 'white':
            return 'btn btn-white';
        case 'black':
            return 'btn';
        case 'green':
        default:
            return 'btn btn-primary';
    }
}
const priceLabelStyle = { fontSize: '16px', fontWeight: 600, marginBottom: '16px' };
const infoIconStyle = {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '16px',
    height: '16px',
    borderRadius: '50%',
    border: '1px solid black',
    background: '#000',
    color: '#fff',
    fontSize: '12px',
    fontWeight: 700,
    marginLeft: '6px',
    cursor: 'pointer',
    verticalAlign: 'middle',
    fontStyle: 'normal',
    position: 'relative'
};
const tooltipStyle = {
    position: 'absolute',
    bottom: '100%',
    left: '50%',
    transform: 'translateX(-50%) translateY(-8px)',
    padding: '8px 12px',
    background: '#fff',
    color: '#000',
    fontSize: '12px',
    lineHeight: 1.4,
    borderRadius: '6px',
    fontStyle: 'normal',
    whiteSpace: 'normal',
    fontWeight: 400,
    minWidth: '200px',
    maxWidth: '350px',
    zIndex: 1000,
    boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
    pointerEvents: 'none'
};
function LabelWithTooltip({ label, tooltip, style }) {
    const [isVisible, setIsVisible] = useState(false);
    const showTooltip = () => tooltip && setIsVisible(true);
    const hideTooltip = () => setIsVisible(false);
    return (React.createElement("div", { style: style },
        label,
        tooltip && (React.createElement("span", { style: infoIconStyle, "aria-label": tooltip, onMouseEnter: showTooltip, onMouseLeave: hideTooltip },
            "i",
            isVisible && (React.createElement("span", { style: tooltipStyle }, tooltip))))));
}
const calculatedLabelStyle = { fontSize: '14px', fontWeight: 600, marginBottom: '6px' };
const calculatedValueStyle = { fontSize: '18px', fontWeight: 700 };
const servicePriceValueStyle = { fontSize: '32px', fontWeight: 700, lineHeight: 1, color: '#2e7d32' };
export function ValidationAndResult({ validationErrors, calculateButtonLabel, calculateButtonColor, onCalculate, hasCalculated, servicePriceLabel, servicePriceTooltip, servicePrice, trafficChargePriceLabel, trafficChargePriceTooltip, trafficChargePrice, segmentPriceLabel, segmentPriceTooltip, segmentPrice }) {
    const { __ } = useI18n();
    return (React.createElement("div", { className: "margin-top-20" },
        validationErrors.length > 0 && (React.createElement("div", { style: {
                marginBottom: '15px',
                padding: '12px',
                background: '#ffebee',
                border: '1px solid #f44336',
                borderRadius: '6px',
                color: '#c62828'
            } },
            React.createElement("strong", null, __('Užpildykite privalomus laukus:', 'ltg-widgets')),
            React.createElement("ul", { style: { margin: '8px 0 0 20px', padding: 0 } }, validationErrors.map((err, i) => (React.createElement("li", { key: i }, err)))))),
        React.createElement("button", { type: "button", onClick: onCalculate, className: getCalculateButtonClassName(calculateButtonColor), style: { marginBottom: '15px' } }, calculateButtonLabel),
        React.createElement("div", { style: { marginTop: '20px' } },
            React.createElement("div", { className: "route-calc-results" },
                React.createElement("div", { className: 'calc-result' },
                    servicePriceLabel && (React.createElement(LabelWithTooltip, { label: servicePriceLabel, tooltip: servicePriceTooltip, style: priceLabelStyle })),
                    React.createElement("div", { style: servicePriceValueStyle },
                        hasCalculated && servicePrice !== null ? formatNumber(servicePrice, 2) : '-',
                        " ",
                        __('Eur', 'ltg-widgets'))),
                React.createElement("div", { className: 'calc-result' },
                    trafficChargePriceLabel && (React.createElement(LabelWithTooltip, { label: trafficChargePriceLabel, tooltip: trafficChargePriceTooltip, style: priceLabelStyle })),
                    React.createElement("div", { style: calculatedValueStyle },
                        hasCalculated && trafficChargePrice !== null ? formatNumber(trafficChargePrice, 2) : '-',
                        " ",
                        __('Eur', 'ltg-widgets'))),
                React.createElement("div", { className: 'calc-result' },
                    segmentPriceLabel && (React.createElement(LabelWithTooltip, { label: segmentPriceLabel, tooltip: segmentPriceTooltip, style: priceLabelStyle })),
                    React.createElement("div", { style: calculatedValueStyle },
                        hasCalculated && segmentPrice !== null ? formatNumber(segmentPrice, 2) : '-',
                        " ",
                        __('Eur', 'ltg-widgets')))))));
}
